"use client";

import { useEffect, useRef } from "react";
import { trackLeadAction } from "@/lib/actions/leads";
import { track, LEAD_EVENTS } from "@/lib/analytics";

/**
 * Invisible client component — fires a profile_view lead once on mount.
 * Renders nothing; purely a side-effect component.
 */
export default function ProfileViewTracker({ professionalId }: { professionalId: string }) {
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    trackLeadAction(professionalId, "profile_view").catch(() => {});
    track(LEAD_EVENTS.profileView, { professionalId });
  }, [professionalId]);

  return null;
}
